import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import FormBillingRules from "../../components/Billing/FormBillingRules";
import AdminLayout from "../../layouts/AdminLayout";

export default function FormBillingRulesPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";
  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      <div className="mt-8 px-4 md:px-8">
        <FormBillingRules />
      </div>
    </AdminLayout>
  );
}
